import { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';

export function DreConfigTitle({ title, children }: { title?: string; children?: ReactNode }) {
    return (
        <Box sx={{ py: 0.5, px: 2, height: 40, backgroundColor: 'primary.main', display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="subtitle1" sx={{ color: 'common.white' }}>
                {title}
            </Typography>

            {children}
        </Box>
    );
}
